import { Component, InputSignal, Signal, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';

export enum DeliveryEstimateBucket {
  Tomorrow = 'tomorrow',
  WithinThreeDays = 'withinThreeDays',
  DateRange = 'dateRange',
  WithinTwoDays = 'withinTwoDays',
}

@Component({
  selector: 'app-delivery-estimate-strip',
  templateUrl: './delivery-estimate-strip.component.html',
  imports: [DatePipe],
})
export class DeliveryEstimateStripComponent {
  dayDifference: InputSignal<number | undefined> = input<number | undefined>(undefined);
  expectedDeliveryDate: InputSignal<{ from?: Date; to?: Date }> = input<{ from?: Date; to?: Date }>({});

  protected readonly Bucket: typeof DeliveryEstimateBucket = DeliveryEstimateBucket;

  protected readonly bucket: Signal<DeliveryEstimateBucket> = computed((): DeliveryEstimateBucket => {
    const dayDifference = this.dayDifference();
    const range = this.expectedDeliveryDate();
    if (dayDifference == null) return DeliveryEstimateBucket.WithinTwoDays;
    if (dayDifference >= 0 && dayDifference <= 1) return DeliveryEstimateBucket.Tomorrow;
    if (dayDifference === 3) return DeliveryEstimateBucket.WithinThreeDays;
    if (dayDifference > 3 && range?.from && range?.to) return DeliveryEstimateBucket.DateRange;
    return DeliveryEstimateBucket.WithinTwoDays;
  });
}
